module.exports = __webpack_public_path__ + "img/words.e26cead1.png";